import { render, staticRenderFns } from "./RegisterFirebaseToken.vue?vue&type=template&id=7dcc159f"
import script from "./RegisterFirebaseToken.vue?vue&type=script&lang=ts"
export * from "./RegisterFirebaseToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports